import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SectionTextModel } from '../../../model/sectionTextModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { Subscription } from 'rxjs';
import { IndividualRenewalService } from '../individual-renewal.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { MessageModel } from '../../../model/models';
import { SubmitIndividualCorporationStatusRequestModel } from '../../../model/submitIndividualCorporationStatusRequestModel';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import * as $ from 'jquery';
import { EntityRenewalService } from '../../entity-renewal/entity-renewal.service';
import { WorkflowModel } from '../../../model/workflowModel';

@Component({
  selector: 'app-individual-corporation-status',
  templateUrl: './individual-corporation-status.component.html',
  styleUrls: ['./individual-corporation-status.component.css']
})
export class IndividualCorporationStatusComponent implements OnInit, OnDestroy {
  
  ngOnDestroy(): void {
    this.notifySubmitQuestionnaireAnswersSubscription.unsubscribe();
    this.notifyQuestionListSubscription.unsubscribe();
    this.currentPageWatcher.clearUserMessage();
  }
  
  agree: boolean = false;
  userMessages: Array<MessageModel> = [];

  corporationRequest :SubmitIndividualCorporationStatusRequestModel = new SubmitIndividualCorporationStatusRequestModel();
  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifyQuestionListSubscription: Subscription = new Subscription();
  submitQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  questions: Array<QuestionnaireQuestionModel> = [];
  startFunction: StartFunctionResponseModel = {};
  headerContent : SectionContentModel = new SectionContentModel;
  workflow: WorkflowModel = new WorkflowModel();

  constructor(private individualRenewalService: IndividualRenewalService,
    private router: Router,
    private currentPageWatcher: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private storage : StorageService,
    private entityRenewalService : EntityRenewalService) {
      
     

    let textModelPart1 : SectionTextModel = new SectionTextModel();
    textModelPart1.text="You are currently licensed with a corporation status and must attest that you are in good standing with the Corporation Commission. Click";
    textModelPart1.href="https://ecorp.azcc.gov/EntitySearch/Index";
    textModelPart1.newPage = true;
    textModelPart1.link="here";

    //window.open(textModelPart1.href, "_blank");

    let textModelPart2 : SectionTextModel = new SectionTextModel();
    textModelPart2.text="to open the Corporation Commission web site. You can choose to continue without the corporation status by not checking below and your license will be modified accordingly.";
    
    this.headerContent.textList.push(textModelPart1);
    this.headerContent.textList.push(textModelPart2);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);

    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
      
    });

    this.notifyQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
      this.questions = questionListData;
    });
   }

  ngOnInit() {
    this.startFunction = this.storage.getStartFunctionData();

    if(this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel==null){
      this.workflow = this.startFunction.Workflow;
    }
    else{
      this.workflow = this.entityRenewalService.renewalWorkflowModel;
    }
    
    this.corporationRequest.WorkflowID = this.workflow.WorkflowID;
    this.corporationRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
  }
continue(){

    this.currentPageWatcher.clearHeaderContent();
    console.log("agree?? = ", this.corporationRequest.ContinueWithCorporationStatus);
    // if (this.corporationRequest.ContinueWithCorporationStatus == false) {
    //   let userMessage: MessageModel = {};
    //   userMessage.Alert = 3;
    //   userMessage.Description = "You must check the box below to continue.";
    //   this.userMessages.push(userMessage);
    //   $("html, body").animate({ scrollTop: 0 }, "slow");
    //   this.currentPageWatcher.sendUserMessages(this.userMessages);
    //   this.userMessages = [];
    // }

    // else {

      this.individualRenewalService.submitCorporationStatus(this.corporationRequest).subscribe(
        (response :SubmitIndividualCorporationStatusResponseModel) =>{

          response.UserMessages.forEach(el => this.userMessages.push(el));
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          if (response.Summary == 0){ 
            this.entityRenewalService.renewalWorkflowModel = response.Workflow;
             //save startFunction with updated workflow in localstorage
             this.startFunction.Workflow.CurrentStepIndex = (this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex ? this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex : null);
             this.startFunction.Workflow.WorkflowID = (this.entityRenewalService.renewalWorkflowModel.WorkflowID ? this.entityRenewalService.renewalWorkflowModel.WorkflowID : null);
             this.startFunction.Workflow.WorkflowDisplayName = (this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName ? this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName : null);
             this.startFunction.Workflow.Fees = (this.entityRenewalService.renewalWorkflowModel.Fees ? this.entityRenewalService.renewalWorkflowModel.Fees : null);
             for (let i = 0; i < this.entityRenewalService.renewalWorkflowModel.Steps.length; i++) {
               this.startFunction.Workflow.Steps[i].StepDisplayName = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepDisplayName;
               this.startFunction.Workflow.Steps[i].StepMessage = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepMessage;
               this.startFunction.Workflow.Steps[i].WorkflowStepStatus = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepStatus;
               this.startFunction.Workflow.Steps[i].WorkflowStepType = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepType;
 
             }
             this.storage.setStartFunctionData(this.startFunction);
             
            if ((this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("offices")) {
           //redirect to inactive offices
           this.router.navigate(["/inactiveOfficesToRenew"]).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(response);
            this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
            this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
            
            
          });
            this.userMessages = [];
          }

          if ( (this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).WorkflowStepType==20) {
            //redirect to reviewEntityRenewal
            this.router.navigate(["/reviewEntityRenewal"]).then(()=>{
              this.startFunctionService.getNotifyStepInProgress().emit(true);
             
              this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
              this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(response);
              this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
            })
             this.userMessages = [];
           }
           if ( (this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).WorkflowStepType==53) {
            //redirect to questionnaireEntityRenewal
            this.router.navigate(["/entityRenewalQuestionnaire"]).then(()=>{
              this.startFunctionService.getNotifyStepInProgress().emit(true);
             
              this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
              this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(response);
              this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
            })
             this.userMessages = [];
           }
}
          if (response.Summary == 1) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            this.userMessages = [];
          }
          if (response.Summary == 2) {
            this.router.navigate(["/home"]);
            this.userMessages = [];
          }
        }
      )
        
    // }
  }

  goBack(){
    this.currentPageWatcher.clearHeaderContent();
    if ( (this.startFunction.Workflow.Steps[this.submitQuestionnaireAnswersResponseModel.Workflow.CurrentStepIndex - 1]).WorkflowStepType==18) {
      //redirect to "/verifyIndividualRenewalQuestionnaire" 
      this.router.navigate(["/verifyIndividualRenewalQuestionnaire"]).then(()=>{
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
      })
       this.userMessages = [];
     }
  }

   //back browser button
   @HostListener('window:popstate', ['$event'])
   onPopState(event) {
     this.goBack();
   }
}



// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-corporation-status/individual-corporation-status.component.ts